import React, { Component } from "react";
import { Card, Row, Col, Form, Button, Offcanvas } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import configData from "../config.json";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Link } from "react-router-dom";
export default class PosscTwo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      isEditing: false,
      data: [],
      currentPage: 1,
      itemsPerPage: 10,
      pfName: "",
      plName: "",
      pmobilenumber: "",
      panPath: "",
      aadharPath: "",
      pospId: "",
      addressLine: "",
      pincode: "",
      areaCd: "",
      cityCd: "",
      stateCd: "",
      irdabranch: "",
      pannumber: "",
      aadharnumber: "",
      emailid: "",
      sscPath: "",
      accName: "",
      accNO: "",
      bankName: "",
      ifscCode: "",
      branchCode: "",
      chequePath: "",
      fullName: "",
      amobilenumber: "",
      aemailid: "",
      apincode: "",
      aareaCd: "",
      acityCd: "",
      aAddressLine: "",
      astateCd: "",
      createdBy: 0,
      error: "",
      tableClms: [
        {
          name: "S.NO",
          width: "75px",
          selector: (row, i) => row.pospId,
          sortable: true,
          cell: (row) => <span>{row.pospId}</span>,
        },
        {
          name: "First Name",
          id: "pfName",
          selector: (row, i) => row.pfName,
          sortable: true,
          cell: (row) => <span>{row.pfName}</span>,
        },
        {
          name: "Last Name",
          id: "plName",
          selector: (row, i) => row.plName,
          sortable: true,
          cell: (row) => <span>{row.plName}</span>,
        },

        {
          name: "Mobile Number",
          id: "pmobilenumber",
          selector: (row, i) => row.pmobilenumber,
          sortable: true,
          cell: (row) => <span>{row.pmobilenumber}</span>,
        },
        {
          name: "PAN",
          id: "pannumber",
          selector: (row, i) => row.pannumber,
          sortable: true,
          cell: (row) => <span>{row.pannumber}</span>,
        },
        {
          name: "Aadhar Number",
          id: "aadharnumber",
          selector: (row, i) => row.aadharnumber,
          sortable: true,
          cell: (row) => <span>{row.aadharnumber}</span>,
        },
        {
          name: "Email-Id",
          id: "emailid",
          selector: (row, i) => row.emailid,
          sortable: true,
          cell: (row) => <span>{row.emailid}</span>,
        },
        {
          name: "Address",
          id: "addressLine",
          selector: (row, i) => row.addressLine,
          sortable: true,
          cell: (row) => <span>{row.addressLine}</span>,
        },

        {
          name: "Pincode",
          id: "pincode",
          selector: (row, i) => row.pincode,
          sortable: true,
          cell: (row) => <span>{row.pincode}</span>,
        },
        {
          name: "Area",
          id: "areaCd",
          selector: (row, i) => row.areaCd,
          sortable: true,
          cell: (row) => <span>{row.areaCd}</span>,
        },

        {
          name: "State",
          id: "stateCd",
          selector: (row, i) => row.stateCd,
          sortable: true,
          cell: (row) => <span>{row.stateCd}</span>,
        },
        {
          name: "Irda Branch",
          id: "irdabranch",
          selector: (row, i) => row.irdabranch,
          sortable: true,
          cell: (row) => <span>{row.irdabranch}</span>,
        },
        {
          name: "Bank Name",
          id: "bankName",
          selector: (row, i) => row.bankName,
          sortable: true,
          cell: (row) => <span>{row.bankName}</span>,
        },
        {
          name: "Account Number",
          id: "accNO",
          selector: (row, i) => row.accNO,
          sortable: true,
          cell: (row) => <span>{row.accNO}</span>,
        },
        {
          name: "IFSC Code",
          id: "ifscCode",
          selector: (row, i) => row.ifscCode,
          sortable: true,
          cell: (row) => <span>{row.ifscCode}</span>,
        },
        {
          name: "Branch Code",
          id: "branchCode",
          selector: (row, i) => row.branchCode,
          sortable: true,
          cell: (row) => <span>{row.branchCode}</span>,
        },
        {
          name: "Alernate Person Full Name",
          id: "fullName",
          selector: (row, i) => row.fullName,
          sortable: true,
          cell: (row) => <span>{row.fullName}</span>,
        },
        {
          name: "IFSC Code",
          id: "ifscCode",
          selector: (row, i) => row.ifscCode,
          sortable: true,
          cell: (row) => <span>{row.ifscCode}</span>,
        },
        {
          name: "Alternate Person Mobile Number",
          id: "amobilenumber",
          selector: (row, i) => row.amobilenumber,
          sortable: true,
          cell: (row) => <span>{row.amobilenumber}</span>,
        },
        {
          name: "Alternate Person Email Id",
          id: "aemailid",
          selector: (row, i) => row.aemailid,
          sortable: true,
          cell: (row) => <span>{row.aemailid}</span>,
        },
        {
          name: "Alternate Person Address",
          id: "aAddressLine",
          selector: (row, i) => row.aAddressLine,
          sortable: true,
          cell: (row) => <span>{row.aAddressLine}</span>,
        },
        {
          name: "Alternate Person Pincode",
          id: "apincode",
          selector: (row, i) => row.apincode,
          sortable: true,
          cell: (row) => <span>{row.apincode}</span>,
        },
        {
          name: "Alternate Person Area",
          id: "aareaCd",
          selector: (row, i) => row.aareaCd,
          sortable: true,
          cell: (row) => <span>{row.aareaCd}</span>,
        },
        {
          name: "AlternatePerson City",
          id: "acityCd",
          selector: (row, i) => row.acityCd,
          sortable: true,
          cell: (row) => <span>{row.acityCd}</span>,
        },

        {
          name: "IRDA Office",
          id: "irdabranch",
          selector: (row, i) => row.irdabranch,
          sortable: true,
          cell: (row) => <span>{row.irdabranch}</span>,
        },
        {
          name: "Remarks",
          id: "remarks1",
          selector: (row, i) => row.remarks1,
          sortable: true,
          cell: (row) => (
            <span style={{ color: "red" }}>
              <b>{row.remarks1}</b>
            </span>
          ),
        },

        {
          name: "Actions",
          sortable: false,
          cell: (row) => (
            <div>
              {/* edit button and delete button */}
              <Button
                variant="primary"
                onClick={() => this.handleEnterEditMode(row)}
                className="bi bi-box-arrow-in-up"
                style={{ marginRight: "3px" }}
              ></Button>
              {/* <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              ></Button> */}
            </div>
          ),
        },
      ],
    };
  }
  showToast = (msg, type) => {
    var tType = toast.TYPE.INFO;
    if (type === "success") tType = toast.TYPE.SUCCESS;
    if (type === "error") tType = toast.TYPE.ERROR;
    if (type === "warning") tType = toast.TYPE.WARNING;
    toast(msg, { type: tType });
  };
  handleShow = () => {
    this.setState({ show: true });
  };
  // Offcanvas close button
  handleOffcanvasClose = () => {
    this.setState({ isEditing: false });
  };
  handleEnterEditMode = (row) => {
    // this.setState({ cData: { ...row }, isEditing: true });
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);

    var pDob = "";
    if (row.pDob !== "0000-00-00") pDob = row.pDob;
    this.setState({
      pfName: row.pfName,
      plName: row.plName,
      pDob: pDob,
      pGender: row.pGender,
      pmobilenumber: row.pmobilenumber,
      pannumber: row.pannumber,
      aadharnumber: row.aadharnumber,
      emailid: row.emailid,
      panPath: row.panPath,
      aadharPath: row.aadharPath,
      addressLine: row.addressLine,
      pincode: row.pincode,
      branchCode: row.branchCode,
      areaCd: row.areaCd,
      cityCd: row.cityCd,
      irdabranch: row.irdabranch,
      sscPath: row.sscPath,
      chequePath: row.chequePath,
      pPhoto: row.pPhoto,
      accName: row.accName,
      apincode: row.apincode,
      aemailid: row.aemailid,
      fullName: row.amobilenumber,
      amobilenumber: row.amobilenumber,
      aareaCd: row.aareaCd,
      accNO: row.accNO,
      bankName: row.bankName,
      ifscCode: row.ifscCode,
      acityCd: row.acityCd,
      aAddressLine: row.aAddressLine,
      astateCd: row.astateCd,
      pospId: row.pospId,
      createdBy: row.createdBy,
      isEditing: true,
    });
  };
  //   handleDelete = (row, index) => {
  //   var formData = new FormData();
  //   formData.append("sId", this.state.sId);
  //   formData.append("uId", this.state.uId);

  //   const pospId = row.pospId;
  //   // console.log(e.target.parentElement);
  //   formData.append("pospId", pospId);
  //   fetch(configData.api_url + "posps/delete", {
  //     // Enter your IP address here
  //     method: "POST",
  //     //headers :{ 'Content-Type' : 'application/json'},
  //     mode: "cors",
  //     body: formData, // body data type must match "Content-Type" header
  //   })
  //     .then((response) => response.json())
  //     .then((data) => {
  //       this.showToast(data.message, data.status);
  //       if (data.status === "success") {
  //         this.PospfetchHandler();
  //       }
  //     });
  //   //implement your delete logic here
  // };
  componentDidMount() {
    this.PospfetchHandler();
  }
  PospfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("pospId", this.state.pospId);

    fetch(configData.api_url + "posps/lsitbyuId", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((rsdata) => {
        console.log("API Response:", rsdata);
        this.showToast(rsdata.message, rsdata.status);
        if (rsdata.status === "success") {
          const list = rsdata.list;
          const data = [];
          list.forEach((element) => {
            if (element.pStatus === "3" || element.pStatus === "5") {
              console.log(element.pStatus);
              data.push(element);
            }
          });
          this.setState({ data: data });
        }
      })

      .catch((error) => {
        console.error("API Error:", error);
        this.showToast("Failed to Fetch Data", "error");
      });
  };
  handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "addressLine" && value.length >= 60) {
      toast.error("Input should not exceed 60 characters.");
    }
    if (name === "fullName") {
      const lettersAndSpacesRegex = /^[A-Za-z\s]*$/;
      if (!lettersAndSpacesRegex.test(value) && value !== "") {
        toast.error("Not allowed special characters and Numbers.");

        return;
      }
    }
    if (
      name === "amobilenumber" &&
      value.length > 0 &&
      value.charAt(0) === "0"
    ) {
      // Display an error toast message or handle the error as needed
      toast.error("Mobile Number cannot start with the number 0.");
      return; // Stop further processing for this field
    }

    if (name === "amobilenumber" && value.length > 0) {
      const firstDigit = parseInt(value.charAt(0), 10);

      if (firstDigit < 6 || firstDigit > 9) {
        // Display an error toast message or handle the error as needed
        toast.error("Please enter valid mobile number.");
        return; // Stop further processing for this field
      }
    }
    if (name === "pincode" && value.length > 0 && value.charAt(0) === "0") {
      // Display an error toast message or handle the error as needed
      toast.error("Pincode cannot start with the number 0.");
      return; // Stop further processing for this field
    }

    this.setState({
      [name]: value,
      errors: {
        ...this.state.errors,
        [name]: "", // Clear the corresponding error when the field value changes
      },
    });
  };

  handleInputPChange = (e) => {
    const { name, value } = e.target;

    if (name === "pincode" && value.length > 0 && value.charAt(0) === "0") {
      // Display an error toast message or handle the error as needed
      toast.error("Pincode cannot start with the number 0.");
      return; // Stop further processing for this field
    }

    this.setState({
      [name]: value,
      errors: {
        ...this.state.errors,
        [name]: "", // Clear the corresponding error when the field value changes
      },
    });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };
  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handleSubmit = (e, status) => {
    e.preventDefault();
    const {
      accName,
      accNO,
      bankName,
      ifscCode,
      branchCode,
      pincode,
      fullName,
      aemailid,
      aareaCd,
      acityCd,
      astateCd,
      irdabranch,
      apincode,
    } = this.state;

    if (!accName || accName.trim() === "") {
      this.showToast("Please Enter Account Holder Name", "error");
      return;
    } else if (!accNO || accNO.trim() === "") {
      this.showToast("Please Enter Account Number", "error");
      return;
    } else if (!bankName || bankName.trim() === "") {
      this.showToast("Please Enter Bank Name", "error");
      return;
    } else if (!ifscCode || ifscCode.trim() === "") {
      this.showToast("Please Enter IFSC Code", "error");
      return;
    } else if (!branchCode || branchCode.trim() === "") {
      this.showToast("Please Enter Branch Code", "error");
      return;
    } else if (!fullName || fullName.length === 0) {
      this.showToast("Please Enter Alternate Person Full Name", "error");
      return;
    } else if (!aemailid || aemailid.trim() === "") {
      this.showToast("Please Enter Your Email Id", "error");
      return;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(aemailid)) {
      this.showToast("Please Enter a Valid Email Id", "error");
      return;
    }
    if (!pincode || pincode.trim() === "") {
      this.showToast("Please Enter Your  Zipcode", "error");
      return false;
    } else if (!pincode || pincode.length !== 6) {
      this.showToast("Please Enter 6 Digit Zipcode", "error");
      return false;
    } else if (!aareaCd || aareaCd.length === 0) {
      this.showToast("Please Enter Alternate Person Area", "error");
      return;
    } else if (!accName || accName.trim() === "") {
      this.showToast("Please Enter Account Holder Name", "error");
      return;
    } else if (!acityCd || acityCd.length === 0) {
      this.showToast("Please Enter Alternate Person City", "error");
      return;
    } else if (!astateCd || astateCd.length === 0) {
      this.showToast("Please Enter Alternate Person State", "error");
      return;
    } else if (!irdabranch || irdabranch.length === 0) {
      this.showToast("Please Select IRDA Office", "error");
      return;
    }
    if (!apincode || apincode.trim() === "") {
      this.showToast("Please Enter Your  Zipcode", "error");
      return false;
    } else if (!apincode || apincode.length !== 6) {
      this.showToast("Please Enter 6 Digit Zipcode", "error");
      return false;
    }
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("pospId", this.state.pospId);
    formData.append("pStatus", status);
    formData.append("accName", this.state.accName);
    formData.append("accNO", this.state.accNO);
    formData.append("cityCd", this.state.cityCd);
    formData.append("areaCd", this.state.areaCd);
    formData.append("stateCd", this.state.stateCd);
    formData.append("bankName", this.state.bankName);
    formData.append("ifscCode", this.state.ifscCode);
    formData.append("branchCode", this.state.branchCode);
    formData.append("pincode", this.state.pincode);
    formData.append("panPath", this.state.panPath);
    formData.append("fullName", this.state.fullName);
    formData.append("aemailid", this.state.aemailid);
    formData.append("amobilenumber", this.state.amobilenumber);
    formData.append("aareaCd", this.state.aareaCd);
    formData.append("acityCd", this.state.acityCd);
    formData.append("astateCd", this.state.astateCd);
    formData.append("irdabranch", this.state.irdabranch);
    formData.append("apincode", this.state.apincode);
    formData.append("aAddressLine", this.state.aAddressLine);
    formData.append("addressLine", this.state.addressLine);
    formData.append("createdBy", this.state.createdBy);
    // Assuming you want to make an API call here
    fetch(configData.api_url + "posps/update/", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("API Response:", data);
        this.showToast(data.message, data.status);

        if (data.status === "success") {
          // Reset form fields upon successful submission

          this.setState({
            pfName: "",
            plName: "",
            pannumber: "",
            pmobilenumber: "",
            aadharnumber: "",
            emailid: "",
            panPath: "",
            aadharPath: "",
            accName: "",
            lName: "",
            bankName: "",
            ifscCode: "",
            branchCode: "",
            sscPath: "",
            chequePath: "",
            fullName: "",
            irdabranch: "",
            amobilenumber: "",
            aemailid: "",
            apincode: "",
            aareaCd: "",
            acityCd: "",
            astateCd: "",
            aAddressLine: "",
            addressLine: "",
            areaCd: "",
          });
          this.handleOffcanvasClose();
          sessionStorage.setItem("pospId", data.pospId);
          // Navigate to the policies page
          // window.location.href = "/markup";
        }
        // setTimeout(() => {
        //    window.location.reload();
        // }, 500);
      })
      .catch((error) => {
        console.error("API Error:", error);
        this.showToast("Failed to submit form", "error");
      });
  };

  // pan pdf view
  openPDFInNewTab = (panPath) => {
    window.open(configData.api_url + panPath, "_blank");
  };
  openPDFAadharNewTab = (aadharPath) => {
    window.open(configData.api_url + aadharPath, "_blank");
  };

  openPDFSSCNewTab = (sscPath) => {
    window.open(configData.api_url + sscPath, "_blank");
  };
  openPDFChequeNewTab = (chequePath) => {
    window.open(configData.api_url + chequePath, "_blank");
  };
  openPDFPhotoNewTab = (pPhoto) => {
    window.open(configData.api_url + pPhoto, "_blank");
  };

  onKeyDown = (e) => {
    if (e.key === " ") {
      e.preventDefault();
      toast.error("Spaces are not allowed.");
    }
  };
  render() {
    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
          (this.state.currentPage - 1) * this.state.itemsPerPage,
          this.state.currentPage * this.state.itemsPerPage
        )
      : this.state.data.slice(
          (this.state.currentPage - 1) * this.state.itemsPerPage,
          this.state.currentPage * this.state.itemsPerPage
        );
    //      if (this.state.pStatus ==="2") {
    //   return <div>You do not have access to this page.</div>;
    // }

    return (
      <div>
        <Row>
          <Col lg="12" md="12" sm="12" xs="12">
            <div className="x_panel">
              <div className="x_content">
                <div className="dataTables_wrapper form-inline dt-bootstrap no-footer">
                  <Row>
                    <div className="" style={{ float: "left" }}>
                      <h3 className="logoskybluecolor">
                        POSP Additional Details{" "}
                      </h3>
                    </div>
                    <Col>
                      {this.state.isEditing && (
                        <Offcanvas
                          show={this.state.isEditing}
                          onHide={() => this.setState({ isEditing: false })}
                          {...this.props}
                          style={{ width: "600px", height: "auto" }}
                          placement="end"
                          backdrop="true"
                        >
                          <Offcanvas.Header closeButton>
                            <Offcanvas.Title>
                              {" "}
                              <h3 className="logoskybluecolor">
                                Additional Details
                              </h3>
                            </Offcanvas.Title>
                          </Offcanvas.Header>
                          <Offcanvas.Body>
                            <Card>
                              <Card.Body>
                                <Row>
                                  <Col lg="6" md="6" sm="12" xs="12">
                                    <Form>
                                      <Form.Group
                                        className="mb-3"
                                        controlId="formBasicEmail"
                                      >
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          First Name
                                        </Form.Label>
                                        <Form.Control
                                          type="text"
                                          //  onChange={this.handleChange}
                                          className="form-control"
                                          name="pfName"
                                          value={this.state.pfName}
                                          required="required"
                                          placeholder="Enter First Name"
                                          disabled={true}
                                        />
                                      </Form.Group>
                                    </Form>
                                  </Col>
                                  <Col lg="6" md="6" sm="12" xs="12">
                                    <Form>
                                      <Form.Group
                                        className="mb-3"
                                        controlId="formBasicEmail"
                                      >
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Last Name
                                        </Form.Label>
                                        <Form.Control
                                          type="text"
                                          //  onChange={this.handleChange}
                                          className="form-control"
                                          name="plName"
                                          value={this.state.plName}
                                          required="required"
                                          placeholder="Enter Last Name"
                                          disabled={true}
                                        />
                                      </Form.Group>
                                    </Form>
                                  </Col>
                                  <Col lg="6" md="6" sm="12">
                                    <Form>
                                      <Form.Group
                                        className="mb-3"
                                        controlId="formBasicEmail"
                                      >
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Gender
                                        </Form.Label>
                                        <Form.Control
                                          type="text"
                                          //  onChange={this.handleChange}
                                          className="form-control"
                                          name="pGender"
                                          value={this.state.pGender}
                                          required="required"
                                          disabled={true}
                                        />
                                      </Form.Group>
                                    </Form>
                                  </Col>
                                  <Col lg="6" md="6" sm="12">
                                    <Form>
                                      <Form.Group
                                        className="mb-3"
                                        controlId="formBasicEmail"
                                        onChange={this.handleChange}
                                      >
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Date Of Birth
                                        </Form.Label>
                                        <DatePicker
                                          dateFormat="dd/MM/yyyy"
                                          showTimeSelect={false}
                                          selected={this.state.pDob}
                                          // onChange={(date) => this.handleDChange(date)}
                                          className="form-control"
                                          id="pDob"
                                          disabled={true}
                                          placeholderText="Select Date of Birth"
                                          peekNextMonth
                                          showMonthD
                                          ropdown
                                          showYearDropdown
                                          // minDate={previousYearStart} // Set the minimum selectable date
                                          // maxDate={endYear} // Set the maximum selectable date
                                        />
                                      </Form.Group>
                                    </Form>
                                  </Col>
                                  <Col lg="12" md="12" sm="12" xs="12">
                                    <Form>
                                      <Form.Group
                                        className="mb-3"
                                        controlId="formBasicEmail"
                                      >
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Mobile Number
                                        </Form.Label>
                                        <Form.Control
                                          onKeyDown={this.onKeyDown}
                                          id="pmobilenumber"
                                          type="text"
                                          name="pmobilenumber"
                                          value={this.state.pmobilenumber}
                                          //  onChange={this.handleChange}
                                          required="required"
                                          placeholder="Enter Mobile Number"
                                          maxLength={10}
                                          disabled={true}
                                        />
                                      </Form.Group>
                                    </Form>
                                  </Col>
                                  <Col lg="12" md="12" sm="12" xs="12">
                                    <Form>
                                      <Form.Group
                                        className=" mb-3"
                                        controlId="formBasicEmail"
                                      >
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Email Id
                                        </Form.Label>
                                        <Form.Control
                                          type="text"
                                          name="emailid"
                                          value={this.state.emailid}
                                          //  onChange={this.handleChange}
                                          required="required"
                                          placeholder="Enter Email-Id"
                                          disabled={true}
                                        />
                                      </Form.Group>
                                    </Form>
                                  </Col>
                                  <Col lg="12" md="12" sm="12" xs="12">
                                    <Form>
                                      <Form.Group
                                        className="mb-3"
                                        controlId="formBasicEmail"
                                      >
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Aadhar Number
                                        </Form.Label>
                                        <Form.Control
                                          type="text"
                                          name="aadharnumber"
                                          value={this.state.aadharnumber}
                                          required="required"
                                          placeholder="Enter Aadhar Number"
                                          // onChange={this.handleChange}
                                          disabled={true}
                                        />
                                      </Form.Group>
                                    </Form>
                                  </Col>
                                  <Col lg="12" md="12" sm="12" xs="12">
                                    <Form>
                                      <Form.Group
                                        className="mb-3"
                                        controlId="formBasicEmail"
                                      >
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          PAN Number
                                        </Form.Label>
                                        <Form.Control
                                          type="text"
                                          //  className="form-control"
                                          name="pannumber"
                                          value={this.state.pannumber}
                                          // onChange={this.handlePANNumberChange}
                                          required="required"
                                          disabled={true}
                                          placeholder="Enter PAN Number"
                                        />
                                      </Form.Group>
                                    </Form>
                                  </Col>
                                </Row>
                                <hr />
                                <Row>
                                  <Col lg="12" md="12" sm="12">
                                    <Form>
                                      <Form.Group
                                        className="mb-3"
                                        controlId="formBasicEmail"
                                      >
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Pan Card Upload
                                        </Form.Label>
                                        <Form.Control
                                          type="text"
                                          disabled={true}
                                          accept=".pdf,.jpg,jpeg,.png"
                                          // onChange={this.handlePanChange}
                                          className="form-control"
                                          name="panPath"
                                          value={this.state.panPath}
                                          required="required"
                                        />
                                      </Form.Group>
                                    </Form>
                                    {this.state.panPath && (
                                      <div>
                                        <Link
                                          onClick={() =>
                                            this.openPDFInNewTab(
                                              this.state.panPath
                                            )
                                          }
                                        >
                                          View Pdf
                                        </Link>
                                      </div>
                                    )}
                                  </Col>
                                  <Col lg="12" md="12" sm="12">
                                    <Form>
                                      <Form.Group
                                        className="mb-3"
                                        controlId="formBasicEmail"
                                      >
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Aadhar Upload
                                        </Form.Label>
                                        <Form.Control
                                          accept=".pdf,.jpg,jpeg,.png"
                                          disabled={true}
                                          type="text"
                                          onChange={this.handleAadharChange}
                                          className="form-control"
                                          name="aadharPath"
                                          value={this.state.aadharPath}
                                          required="required"
                                        />
                                      </Form.Group>
                                    </Form>
                                    {this.state.aadharPath && (
                                      <div>
                                        <Link
                                          onClick={() =>
                                            this.openPDFAadharNewTab(
                                              this.state.aadharPath
                                            )
                                          }
                                        >
                                          View Pdf
                                        </Link>
                                      </div>
                                    )}
                                  </Col>
                                  <hr />
                                  <Col lg="12" md="12" sm="12" xs="12">
                                    <Form>
                                      <Form.Group
                                        className="mb-3"
                                        controlId="formBasicEmail"
                                      >
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Tenth Certificate Upload
                                          <p
                                            style={{
                                              color: "red",
                                              fontSize: "10px",
                                            }}
                                          >
                                            (* .pdf only)
                                          </p>
                                        </Form.Label>
                                        <Form.Control
                                          accept=".pdf,.jpg,jpeg,.png"
                                          disabled={true}
                                          type="text"
                                          value={this.state.sscPath}
                                          // onChange={this.handleTcChange}
                                          className="form-control"
                                          name="sscPath"
                                          required="required"
                                        />
                                      </Form.Group>
                                    </Form>
                                    {this.state.sscPath && (
                                      <div>
                                        <Link
                                          onClick={() =>
                                            this.openPDFSSCNewTab(
                                              this.state.sscPath
                                            )
                                          }
                                        >
                                          View Pdf
                                        </Link>
                                      </div>
                                    )}
                                  </Col>
                                  <Col lg="12" md="12" sm="12" xs="12">
                                    <Form>
                                      <Form.Group
                                        className="mb-3"
                                        controlId="formBasicEmail"
                                      >
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Cheque Upload{" "}
                                          <p
                                            style={{
                                              color: "red",
                                              fontSize: "10px",
                                            }}
                                          >
                                            (* .pdf only)
                                          </p>
                                        </Form.Label>
                                        <Form.Control
                                          accept=".pdf,.jpg,jpeg,.png"
                                          type="text"
                                          value={this.state.chequePath}
                                          disabled={true}
                                          // onChange={this.handleChequeChange}
                                          className="form-control"
                                          name="chequePath"
                                          required="required"
                                        />
                                      </Form.Group>
                                    </Form>
                                    {this.state.chequePath && (
                                      <div>
                                        <Link
                                          onClick={() =>
                                            this.openPDFChequeNewTab(
                                              this.state.chequePath
                                            )
                                          }
                                        >
                                          View Pdf
                                        </Link>
                                      </div>
                                    )}
                                  </Col>
                                  <Col lg="12" md="12" sm="12" xs="12">
                                    <Form>
                                      <Form.Group
                                        className="mb-3"
                                        controlId="formBasicEmail"
                                      >
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Passport Size Color Photo{" "}
                                          <p
                                            style={{
                                              color: "red",
                                              fontSize: "10px",
                                            }}
                                          >
                                            (* .pdf only)
                                          </p>
                                        </Form.Label>
                                        <Form.Control
                                          accept=".pdf,.jpg,jpeg,.png"
                                          type="text"
                                          value={this.state.pPhoto}
                                          // onChange={this.handlepsPhotoChange}
                                          className="form-control"
                                          name="pPhoto"
                                          required="required"
                                          disabled={true}
                                        />
                                      </Form.Group>
                                    </Form>
                                    {this.state.pPhoto && (
                                      <div>
                                        <Link
                                          onClick={() =>
                                            this.openPDFPhotoNewTab(
                                              this.state.pPhoto
                                            )
                                          }
                                        >
                                          View Pdf
                                        </Link>
                                      </div>
                                    )}
                                  </Col>
                                </Row>
                                <hr />
                                <Row>
                                  <Col lg="12" md="12" sm="12" xs="12">
                                    <Form>
                                      <Form.Group
                                        className=" mb-3"
                                        controlId="formBasicEmail"
                                      >
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Account Holder Name
                                        </Form.Label>
                                        <Form.Control
                                          type="text"
                                          name="accName"
                                          value={this.state.accName}
                                          onChange={this.handleChange}
                                          required="required"
                                          placeholder="Enter Account Holder Name"
                                        />
                                      </Form.Group>
                                    </Form>
                                  </Col>
                                  <Col lg="12" md="12" sm="12" xs="12">
                                    <Form>
                                      <Form.Group
                                        className=" mb-3"
                                        controlId="formBasicEmail"
                                      >
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Account Number
                                        </Form.Label>
                                        <Form.Control
                                          type="text"
                                          name="accNO"
                                          value={this.state.accNO}
                                          onChange={this.handleChange}
                                          required="required"
                                          placeholder="Enter Account Number"
                                        />
                                      </Form.Group>
                                    </Form>
                                  </Col>
                                  <Col lg="12" md="12" sm="12" xs="12">
                                    <Form>
                                      <Form.Group
                                        className=" mb-3"
                                        controlId="formBasicEmail"
                                      >
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Bank Name
                                        </Form.Label>
                                        <Form.Control
                                          type="text"
                                          name="bankName"
                                          value={this.state.bankName}
                                          onChange={this.handleChange}
                                          required="required"
                                          placeholder="Enter Bank Name"
                                        />
                                      </Form.Group>
                                    </Form>
                                  </Col>
                                  <Col lg="12" md="12" sm="12" xs="12">
                                    <Form>
                                      <Form.Group
                                        className=" mb-3"
                                        controlId="formBasicEmail"
                                      >
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          IFSC Code
                                        </Form.Label>
                                        <Form.Control
                                          type="text"
                                          name="ifscCode"
                                          value={this.state.ifscCode}
                                          onChange={this.handleChange}
                                          required="required"
                                          placeholder="Enter IFSC Code"
                                        />
                                      </Form.Group>
                                    </Form>
                                  </Col>
                                  <Col lg="12" md="12" sm="12" xs="12">
                                    <Form>
                                      <Form.Group
                                        className=" mb-3"
                                        controlId="formBasicEmail"
                                      >
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Branch Code
                                        </Form.Label>
                                        <Form.Control
                                          type="text"
                                          name="branchCode"
                                          value={this.state.branchCode}
                                          onChange={this.handleChange}
                                          required="required"
                                          placeholder="Enter Branch Code"
                                        />
                                      </Form.Group>
                                    </Form>
                                  </Col>
                                </Row>
                                <hr />
                                <Row>
                                  <h6>Communication Details</h6>
                                  <Col lg="12" md="12" sm="12" xs="12">
                                    <Form>
                                      <Form.Group
                                        className="mb-3"
                                        controlId="formBasicEmail"
                                      >
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Address Line{" "}
                                        </Form.Label>
                                        <Form.Control
                                          as="textarea"
                                          rows={3}
                                          onChange={this.handleChange}
                                          className="form-control"
                                          name="addressLine"
                                          id="addressLine"
                                          value={this.state.addressLine}
                                          required="required"
                                          maxLength={60}
                                          placeholder="Enter Your Address Line"
                                        />
                                      </Form.Group>
                                    </Form>
                                  </Col>
                                  <Col sm="6" md="6" lg="6">
                                    <Form.Group className="form-group">
                                      <Form.Label
                                        className="control-label"
                                        style={{ paddingTop: "8px" }}
                                      >
                                        Pin Code
                                      </Form.Label>
                                      <Form.Control
                                        type="text"
                                        name="pincode"
                                        id="pincode"
                                        value={this.state.pincode}
                                        onChange={this.handleChange}
                                        className="form-control"
                                        aria-describedby="pincode"
                                        placeholder="Pin Code"
                                        maxLength={6}
                                      />
                                    </Form.Group>
                                  </Col>
                                  <Col lg="6" md="6" sm="12" xs="12">
                                    <Form.Group className="form-group">
                                      <Form.Label
                                        className="control-label"
                                        style={{ paddingTop: "8px" }}
                                      >
                                        Area
                                      </Form.Label>
                                      <Form.Control
                                        type="text"
                                        className="form-control"
                                        name="areaCd"
                                        id="areaCd"
                                        value={this.state.areaCd}
                                        onChange={this.handleChange}
                                        aria-describedby="area"
                                        placeholder="Enter Area"
                                      />
                                    </Form.Group>
                                  </Col>
                                  <Col sm="3" lg="6" md="6">
                                    <Form.Group className="form-group">
                                      <Form.Label
                                        className="control-label"
                                        style={{ paddingTop: "8px" }}
                                      >
                                        City
                                      </Form.Label>
                                      <Form.Control
                                        type="text"
                                        className="form-control"
                                        name="cityCd"
                                        id="cityCd"
                                        value={this.state.cityCd}
                                        onChange={this.handleChange}
                                        aria-describedby="cityCd"
                                        placeholder="City"
                                      />
                                    </Form.Group>
                                  </Col>

                                  <Col lg="6" md="6" sm="12" xs="12">
                                    <Form.Group className="form-group">
                                      <Form.Label
                                        className="control-label"
                                        style={{ paddingTop: "8px" }}
                                      >
                                        State
                                      </Form.Label>
                                      <Form.Control
                                        type="text"
                                        className="form-control"
                                        id="stateCd"
                                        aria-describedby="State"
                                        name="stateCd"
                                        value={this.state.stateCd}
                                        onChange={this.handleChange}
                                        placeholder="State"
                                      />
                                    </Form.Group>
                                  </Col>
                                  {/*   <Col lg="12" md="12" sm="12" xs="12">
                            <Form>
                              <Form.Group
                                className="mb-3"
                                controlId="formBasicEmail"
                              >
                                <Form.Label style={{ paddingTop: "8px" }}>
                                Country Name                                
                                </Form.Label>
                                <Form.Control
                                  type="text"
                                  //  className="form-control"
                                   name="CtName"
                                  value={this.state.CtName}
                                  onChange={this.handlePANNumberChange}
                                  required="required"
                                  placeholder="Enter Country Name"
                                />
                              </Form.Group>
                            </Form>
                          </Col> */}
                                </Row>
                                <hr />
                                <Row>
                                  <h6>Alternate Person Details</h6>
                                  <Col lg="12" md="12" sm="12" xs="12">
                                    <Form>
                                      <Form.Group
                                        className="mb-3"
                                        controlId="formBasicEmail"
                                      >
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Full Name
                                        </Form.Label>
                                        <Form.Control
                                          type="text"
                                          onChange={this.handleChange}
                                          className="form-control"
                                          name="fullName"
                                          value={this.state.fullName}
                                          required="required"
                                          placeholder="Enter Full Name"
                                        />
                                      </Form.Group>
                                    </Form>
                                  </Col>
                                  <Col lg="6" md="6" sm="12" xs="12">
                                    <Form>
                                      <Form.Group
                                        className="mb-3"
                                        controlId="formBasicEmail"
                                      >
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Mobile Number
                                        </Form.Label>
                                        <Form.Control
                                          onKeyDown={this.onKeyDown}
                                          id="amobilenumber"
                                          type="text"
                                          name="amobilenumber"
                                          value={this.state.amobilenumber}
                                          onChange={this.handleChange}
                                          required="required"
                                          placeholder="Enter Mobile Number"
                                          maxLength={10}
                                        />
                                      </Form.Group>
                                    </Form>
                                  </Col>
                                  <Col lg="6" md="6" sm="12" xs="12">
                                    <Form>
                                      <Form.Group
                                        className=" mb-3"
                                        controlId="formBasicEmail"
                                      >
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Email Id
                                        </Form.Label>
                                        <Form.Control
                                          type="text"
                                          name="aemailid"
                                          value={this.state.aemailid}
                                          onChange={this.handleChange}
                                          required="required"
                                          placeholder="Enter Email-Id"
                                        />
                                      </Form.Group>
                                    </Form>
                                  </Col>
                                  <Col lg="12" md="12" sm="12" xs="12">
                                    <Form>
                                      <Form.Group
                                        className="mb-3"
                                        controlId="formBasicEmail"
                                      >
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Address Line{" "}
                                        </Form.Label>
                                        <Form.Control
                                          as="textarea"
                                          rows={3}
                                          onChange={this.handleChange}
                                          className="form-control"
                                          name="aAddressLine"
                                          id="aAddressLine"
                                          value={this.state.aAddressLine}
                                          required="required"
                                          maxLength={60}
                                          placeholder="Enter Your Address Line"
                                        />
                                      </Form.Group>
                                    </Form>
                                  </Col>
                                  <Col sm="3" lg="6" md="6">
                                    <Form.Group className="form-group">
                                      <Form.Label
                                        className="control-label"
                                        style={{ paddingTop: "8px" }}
                                      >
                                        Pin Code
                                      </Form.Label>
                                      <Form.Control
                                        type="text"
                                        name="apincode"
                                        id="apincode"
                                        value={this.state.apincode}
                                        onChange={this.handleInputPChange}
                                        className="form-control"
                                        aria-describedby="apincode"
                                        placeholder="Pin Code"
                                        maxLength={6}
                                      />
                                    </Form.Group>
                                  </Col>
                                  <Col lg="6" md="6" sm="12" xs="12">
                                    <Form.Group className="form-group">
                                      <Form.Label
                                        className="control-label"
                                        style={{ paddingTop: "8px" }}
                                      >
                                        Area
                                      </Form.Label>
                                      <Form.Control
                                        type="text"
                                        className="form-control"
                                        name="aareaCd"
                                        id="aareaCd"
                                        value={this.state.aareaCd}
                                        onChange={this.handleChange}
                                        aria-describedby="aareaCd"
                                        placeholder="Enter Area"
                                      />
                                    </Form.Group>
                                  </Col>
                                  <Col sm="3" lg="6" md="6">
                                    <Form.Group className="form-group">
                                      <Form.Label
                                        className="control-label"
                                        style={{ paddingTop: "8px" }}
                                      >
                                        City
                                      </Form.Label>
                                      <Form.Control
                                        type="text"
                                        className="form-control"
                                        name="acityCd"
                                        id="acityCd"
                                        value={this.state.acityCd}
                                        onChange={this.handleChange}
                                        aria-describedby="acityCd"
                                        placeholder="City"
                                      />
                                    </Form.Group>
                                  </Col>

                                  <Col lg="6" md="6" sm="12" xs="12">
                                    <Form.Group className="form-group">
                                      <Form.Label
                                        className="control-label"
                                        style={{ paddingTop: "8px" }}
                                      >
                                        State
                                      </Form.Label>
                                      <Form.Control
                                        type="text"
                                        className="form-control"
                                        id="astateCd"
                                        aria-describedby="State"
                                        name="astateCd"
                                        value={this.state.astateCd}
                                        onChange={this.handleChange}
                                        placeholder="State"
                                      />
                                    </Form.Group>
                                  </Col>
                                </Row>
                                <hr />
                                <Row>
                                  <h6>Branch Details</h6>
                                  <Col lg="12" md="12" sm="12" xs="12">
                                    <Form>
                                      <Form.Group
                                        className=" mb-3"
                                        controlId="formBasicEmail"
                                        name="irdabranch"
                                        onChange={this.handleChange}
                                      >
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          IRDA Branch Details
                                        </Form.Label>
                                        <Form.Select
                                          className="form-control"
                                          name="irdabranch"
                                        >
                                          <option>Select IRDA Office</option>
                                          <option value="ApnapolicyInsuranceBrokers">
                                            Apnapolicy Insurance Brokers{" "}
                                          </option>
                                        </Form.Select>
                                      </Form.Group>
                                    </Form>
                                  </Col>
                                </Row>
                                <hr />
                                <Row>
                                  {/* <Col
                className="d-flex justify-content-start"
                      style={{ marginRight: "5px", marginTop: "20px" }}>
                <Button variant='warning'
                type='submit'
                onClick={this.handleReject}
                >Resend</Button>
                </Col> */}
                                  <Col
                                    className="d-flex justify-content-end"
                                    style={{
                                      marginRight: "5px",
                                      marginTop: "20px",
                                    }}
                                  >
                                    <Button
                                      variant="success"
                                      type="submit"
                                      onClick={(e) => this.handleSubmit(e, "4")}
                                    >
                                      Submit
                                    </Button>
                                  </Col>
                                </Row>
                              </Card.Body>
                            </Card>
                          </Offcanvas.Body>
                        </Offcanvas>
                      )}
                    </Col>
                  </Row>
                  <Row className="mt-5">
                    <div>
                      {/* searchbar,pagination,filter */}
                      <input
                        style={{ float: "left", marginBottom: "10px" }}
                        type="text"
                        onChange={this.handleFilter}
                        placeholder="Search..."
                      />
                      <DataTable
                        data={paginatedData}
                        columns={this.state.tableClms}
                        pagination
                        paginationServer
                        paginationTotalRows={
                          this.state.filteredData
                            ? this.state.filteredData.length
                            : this.state.data.length
                        }
                        //  paginationTotalRows={this.state.posp.add}
                        onChangeRowsPerPage={this.handlePerRowsChange}
                        onChangePage={this.handlePageChange}
                        paginationPerPage={this.state.itemsPerPage}
                        paginationRowsPerPageOptions={[
                          10, 20, 30, 50, 60, 70, 80, 90, 100,
                        ]}
                        keyField="id"
                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                      />
                    </div>
                  </Row>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}
